import { apiSlice } from "@/shared/api/api-slice"

import type { GetUserCardStyleRequest, UserCardStyle, UserCardStyleResponse } from "./card-style-types"

export const getUserCardStyleTag = (chatId: number | null) => ({ type: "UserCardStyle" as const, id: `CHAT_${chatId}` })

export const getUserCardStyleApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["UserCardStyle"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      getUserCardStyle: builder.query<UserCardStyle, GetUserCardStyleRequest>({
        query: ({ chatId }) => `/api/v1/card-styles/me?chat_id=${chatId}`,
        transformResponse: (response: UserCardStyleResponse): UserCardStyle => ({
          activeStyleId: response.active_style_id,
          unlockedStyleIds: response.unlocked_style_ids,
          customUnlocked: response.custom_unlocked,
          customImageUrl: response.custom_image_url
        }),
        providesTags: (_result, _error, { chatId }) => [getUserCardStyleTag(chatId)]
      })
    })
  })

export const { useGetUserCardStyleQuery } = getUserCardStyleApi
